import styled from 'styled-components';
import { vars } from '$util/theme';

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${vars.quantumverse.reskinColors.neutral300};
  }

  .call-us-icon {
    margin-right: 8px;
  }
`;
